/**
 * Turns an original file name into the part of an S3 key the photo DTOs
 * accept (PHOTO_FILE_NAME_PATTERN). Accents are folded to their base letter
 * and anything else outside the pattern becomes "_", so a photo named
 * "café #1.jpg" uploads and records instead of failing the batch POST.
 */
export const toPhotoKeySegment = (name: string): string =>
  name
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^\w.\-()@ ]/g, '_') || 'photo';
